import { StateCreator } from 'zustand'
import { FilterValues, DefaultsSlice, FilterStore } from './types'

const emptyDefaults: FilterValues = {
  orgId: undefined,
  buildingId: undefined,
  // ADD HERE
}

export const createDefaultsSlice: StateCreator<FilterStore, [], [], DefaultsSlice> = (set) => ({
  defaults: emptyDefaults,

  setDefaults(values) {
    set((state) => ({
      defaults: {
        ...state.defaults,
        ...values,
      },
    }))
  },
})
